import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import AssignWidgetImg from "../../../../assests/assignStudyGroup/assignWidget.png";

const AssignCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#D7F8D9"
            title={texts.assignWidgetTeacher}
            image={AssignWidgetImg}
            imageAlt={texts.assignWidgetTeacher}
            link={`/${pathRouts.MYLEARNING}/${pathRouts.ASSIGNSTUDYGTOUP}`}
        />
    );
};

export default AssignCarouselWidget;
